<template>
  <button v-for="(assignment, index) in assignmentList"
          class="fire-list-btn"
          @click.prevent="onClick(assignment.name)"
          :class="assignmentName === assignment.name ? 'is-active' : ''"
          :key="index">{{ assignment.name }}</button>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import {ASSIGNMENTS} from '@/app/core/constants';

export default defineComponent({
  name: 'fire-assignment-list',
  emits: ['selectItem'],
  props: {
    assignmentName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      assignmentList: ASSIGNMENTS,
    };
  },
  methods: {
    onClick(value: string) {
      this.$emit('selectItem', value);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../list-btn";
</style>
